import React, { useMemo, useRef, useState } from 'react';
import { AutocompleteInputPropTypes, AutocompleteInputDefaultPropValues } from './autocomplete-input.prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { SuggestionsContainer, SuggestionsList, SuggestionItem, ArrowIcon } from './AutocompleteInput.styled';
import { Container, InputContainer, Input, InputLabel, Error, Helpers, LabelTxt, TxtPrefix, IconPrefix, TEXT_ALIGN } from './TextInput.styled';
export const AutocompleteInput = ({ onChange, onBlur, defaultValue, disabled, error, label, placeholder, errorMessage, maxLength, prefix, type = 'text', iconPrefix, textAlign = 'left', width, name, inputRef, options, invalidOption, addOptionName, addOptionAction, clearOnSelect, arrowIcon, suggestionsBoxHeight, getAutocompleteValue }) => {
    const [value, setValue] = useState(defaultValue);
    const [outputValue, setOutputValue] = useState();
    const reference = inputRef ? { ref: inputRef } : {};
    const [isSuggestionsVisible, setIsSuggestionsVisible] = useState(false);
    const inputContainerRef = useRef(null);
    const handleChange = (e) => {
        let value;
        if (onChange && getAutocompleteValue) {
            value = getSuggestionValue(e.target.value);
        }
        else if (onChange) {
            value = e.target.value;
        }
        onChange && onChange(value);
        setOutputValue(value);
        setValue(e.target.value);
    };
    const handleBlur = () => {
        onBlur && onBlur(outputValue);
    };
    const handleSuggestionsVisibility = (visibility = true) => setIsSuggestionsVisible(visibility);
    const handleSuggestionSelected = (suggestion) => {
        if (suggestion !== invalidOption && !!suggestion) {
            setIsSuggestionsVisible(false);
            let value;
            if (onChange && getAutocompleteValue) {
                value = getSuggestionValue(suggestion);
            }
            else if (onChange) {
                value = suggestion;
            }
            onChange && onChange(value);
            setOutputValue(value);
            onBlur && onBlur(value);
            setValue(clearOnSelect ? '' : suggestion);
        }
    };
    const handleKeyBoardNavegation = (event) => {
        if (event.key === 'Escape' || event.key === 'Tab') {
            setIsSuggestionsVisible(false);
        }
    };
    const handleArrowIcon = () => !disabled && setIsSuggestionsVisible(!isSuggestionsVisible);
    const suggestions = useMemo(() => {
        if (!value)
            return options;
        const invalidOptionMessage = addOptionName ? [] : [{ name: invalidOption }];
        const filteredSuggestions = options === null || options === void 0 ? void 0 : options.filter(suggestion => { var _a; return (_a = suggestion === null || suggestion === void 0 ? void 0 : suggestion.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(value.toLowerCase()); });
        if ((filteredSuggestions === null || filteredSuggestions === void 0 ? void 0 : filteredSuggestions.length) === 0) {
            onChange && onChange('');
            setOutputValue(value);
        }
        return filteredSuggestions && filteredSuggestions.length > 0
            ? filteredSuggestions
            : invalidOptionMessage;
    }, [options, invalidOption, value]);
    const getSuggestionValue = (suggestionSelected) => {
        const suggestionValue = options === null || options === void 0 ? void 0 : options.find((suggestion) => suggestion && suggestion.name === suggestionSelected);
        return suggestionValue && suggestionValue.value ? suggestionValue.value : '';
    };
    return (React.createElement(Container, { width: width, onMouseLeave: () => handleSuggestionsVisibility(false) },
        React.createElement(InputContainer, { error: error, ref: inputContainerRef },
            prefix && React.createElement(TxtPrefix, null, prefix),
            iconPrefix && (React.createElement(IconPrefix, null,
                React.createElement(FontAwesomeIcon, { icon: iconPrefix }))),
            React.createElement(Input, Object.assign({}, reference, { type: type, "$withPrefix": !!prefix, "$withIconPrefix": !!iconPrefix, onChange: handleChange, onBlur: handleBlur, onClick: () => handleSuggestionsVisibility(), placeholder: placeholder, value: value, onKeyUp: handleKeyBoardNavegation, autoComplete: 'off', disabled: disabled, "$textAlign": TEXT_ALIGN[textAlign] || TEXT_ALIGN.LEFT, maxLength: maxLength, name: name })),
            arrowIcon && (React.createElement(ArrowIcon, { icon: faChevronDown, disabled: disabled, onClick: handleArrowIcon })),
            React.createElement(InputLabel, { showed: !!value },
                React.createElement(LabelTxt, null, label)),
            isSuggestionsVisible && (React.createElement(SuggestionsContainer, { suggestionsBoxHeight: suggestionsBoxHeight },
                React.createElement(SuggestionsList, null, (suggestions === null || suggestions === void 0 ? void 0 : suggestions.length) ?
                    suggestions.map((suggestion, index) => (React.createElement(SuggestionItem, { key: index, disableHighLighted: suggestion.name ===
                            invalidOption, onClick: () => handleSuggestionSelected(suggestion.name) }, suggestion.name))) :
                    addOptionName &&
                        React.createElement(SuggestionItem, { key: addOptionName, disableHighLighted: false, onClick: () => addOptionAction && addOptionAction(value) }, addOptionName + value))))),
        React.createElement(Helpers, null, error && errorMessage && React.createElement(Error, null, errorMessage))));
};
AutocompleteInput.propTypes = AutocompleteInputPropTypes;
AutocompleteInput.defaultProps = AutocompleteInputDefaultPropValues;
//# sourceMappingURL=AutocompleteInput.js.map